import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ScrollArea } from '@/components/ui/scroll-area';
import ClusterResults from '@/routes/(app)/(playground)/(text-translation)/components/cluster-results';

interface OutputCardProps {
  className?: string;
  clusterIds: Array<string>;
}

const OutputCard: FC<OutputCardProps> = ({ className, clusterIds }) => {
  const { t } = useTranslation();
  return (
    <Card
      data-card
      className={className}>
      <CardHeader>
        <CardTitle>{t('playground.textTranslation.output.title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <ScrollArea>
          <div className='flex max-h-[400px] flex-col gap-10'>
            {clusterIds.map((clusterId) => (
              <ClusterResults
                key={clusterId}
                clusterId={clusterId}
              />
            ))}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
};

export default OutputCard;
